// extracted by mini-css-extract-plugin
export var markdown = "_st-0";
export var tableWrapper = "_st-1";